import clsx from "clsx";
import { PropsWithChildren, ReactNode } from "react";
import { SpinnerBlock } from "components/Spinner";

export const CardHeader = (props: { icon?: string; name?: string; center?: boolean }) => {
    const { icon, name, center } = props;

    return (
        <div
            className={clsx(
                "card-header text-white bg-dark h5 d-flex gap-3 align-items-center",
                center && "justify-content-center",
            )}
        >
            {icon && <span className={icon}></span>}
            <span className="text-lg-start">{name}</span>
        </div>
    );
};

export const CardFooter = (props: { footer: ReactNode; loading?: boolean }) => {
    const { footer, loading } = props;

    return (
        <div className="card-footer d-flex flex-lg-row gap-3 align-items-center justify-content-center justify-content-lg-start">
            {footer} {loading && <SpinnerBlock className="ms-lg-auto" />}
        </div>
    );
};

export const CardForm = (
    props: PropsWithChildren<{
        name?: string;
        icon?: string;
        footer?: ReactNode;
        loading?: boolean;
        center?: boolean;
        mobileRow?: boolean;
        fullHeight?: boolean;
        inlineFlex?: boolean;
    }>,
) => {
    const { name, icon, children, footer, loading, center, mobileRow, fullHeight, inlineFlex } = props;

    return (
        <div
            className={clsx(
                "card",
                mobileRow && "flex-row flex-lg-column",
                fullHeight && "h-100",
                inlineFlex && "d-inline-flex",
            )}
        >
            {name && <CardHeader icon={icon} name={name} center={center} />}

            <div className="vstack gap-4 card-body">{children}</div>

            {footer && <CardFooter footer={footer} loading={loading} />}
        </div>
    );
};
